<template>
  <svg class="workflow-drawing-icon" viewBox="0 0 32 32" fill="none" stroke="currentColor" stroke-width="1.65" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">
    <path d="M19 4H5a1 1 0 0 0-1 1v22a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1v-7" />
    <path d="M8 9h5M8 14h3M8 24h10" />
    <path class="workflow-drawing-ink" d="M8 20h9" />
    <g class="workflow-drawing-pencil">
      <path d="m14 20 1-4L25 6l3 3-10 10-4 1Zm1-4 3 3M23 8l3 3" />
      <path d="m14 20 .5-2 1.5 1.5Z" fill="currentColor" stroke="none" />
    </g>
  </svg>
</template>

<style>
.workflow-drawing-pencil { transform-origin: 14px 20px; transition: transform 240ms cubic-bezier(.22, 1, .36, 1); }
.workflow-drawing-ink { stroke-dasharray: 9; stroke-dashoffset: 3; transition: stroke-dashoffset 240ms cubic-bezier(.22, 1, .36, 1); }
.workflow-entry:focus-visible .workflow-drawing-pencil { transform: translateX(3px) rotate(-6deg); transition: none; }
.workflow-entry:focus-visible .workflow-drawing-ink { stroke-dashoffset: 0; transition: none; }
@media (hover: hover) and (pointer: fine) {
  .workflow-entry:hover .workflow-drawing-pencil { transform: translateX(3px) rotate(-6deg); }
  .workflow-entry:hover .workflow-drawing-ink { stroke-dashoffset: 0; }
}
@media (prefers-reduced-motion: reduce) {
  .workflow-drawing-pencil, .workflow-drawing-ink { transition: none; }
}
</style>
